/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ExcludedCompanyAdd {
  /**
     * @minLength 1
     * @maxLength 255
     */
  company_name: string;
  company_domain?: string | null;
}
